function createRandomSuffix(): string {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  return `${Date.now()}${Math.random().toString(36).slice(2)}`;
}

export function generateSessionId(): string {
  return `ses_${createRandomSuffix()}`;
}
